<template>
  <div>
    <el-dialog
      title="函询"
      :visible.sync="dialogVisible"
      width="1103px"
      @close="cancel('ruleForm')"
      :before-close="cancleClick"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    <div v-loading="dialogLoading">
      <el-form
        class="dialogForm"
        label-position="right"
        label-width="79px"
        :model="formLabelAlign"
        :rules="rules"
        ref="ruleForm"
        @submit.native.prevent
      >
        <ApplicantInformation
          v-if="
            ($store.state.user.type == 1 && flag) ||
            ($store.state.user.type == 2 && flag)
          "
          ref="applicantInformation"
          :ruleForm.sync="formLabelAlign"
          :handleInfoDto="formLabelAlign.handleInfoDto"
          :type="$store.state.user.type"
          :isAdd="isAdd"
          :labelW="79"
        >
        </ApplicantInformation>
        <el-form-item label="疑问事项" prop="question">
          <el-input
            type="textarea"
            :rows="2.7"
            placeholder="请输入最少5个字，最多200字"
            resize="none"
            minlength="5"
            maxlength="200"
            show-word-limit
            v-model="formLabelAlign.question"
            :autosize="{ minRows: 2.7, maxRows: 8 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="我的理解" prop="comprehend">
          <el-input
            type="textarea"
            :rows="2.7"
            placeholder="最多输入200字"
            resize="none"
            maxlength="200"
            show-word-limit
            v-model="formLabelAlign.comprehend"
            :autosize="{ minRows: 2.7, maxRows: 8 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="请求答复" prop="requestAnswer">
          <el-input
            type="textarea"
            :rows="2.7"
            placeholder="最多输入200字"
            resize="none"
            maxlength="200"
            show-word-limit
            v-model="formLabelAlign.requestAnswer"
            :autosize="{ minRows: 2.7, maxRows: 8 }"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col
            :span="24"
            v-for="item in formLabelAlign.addFieldListOne"
            :key="item.key"
          >
            <AddBtnCustomizeField
              isNewStyle
              :titleW="200"
              :labelW="79"
              :valueW="750"
              :form-data="item"
              @updateContent="updateCustomizeField"
              @deleteItem="deleteCustomizeField"
              :ref="`customizeField_${item.key}`"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="">
              <el-button
                @click="addCustomizeField(formLabelAlign.addFieldListOne)"
                class="btn-add"
                icon="el-icon-plus"
                style="font-weight:400"
                >新增字段</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传附件" style="margin-bottom: 0">
              <UploadAttachments
                :fileList="formLabelAlign.fileList"
                @changeAttachment="
                  obj => {
                    formLabelAlign.fileList = obj
                  }
                "
              ></UploadAttachments>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="info-item-tt" style="margin-top:20px">联系信息</div>
            <div class="dashed-line"></div>
          </el-col>
        </el-row>
        <el-row class="contactMessage">
          <el-col :span="8">
            <el-form-item label="客户名称" prop="contactName">
              <el-input
                placeholder=""
                :disabled="true"
                v-model="formLabelAlign.contactName"
                class="customer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="联系人"
              label-width="90px"
              prop="contactUserName"
            >
              <el-input
                placeholder="请输入联系人"
                minlength="2"
                maxlength="15"
                v-model="formLabelAlign.contactUserName"
                class="contact"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话" prop="contactTel" label-width="120px">
              <el-input
                placeholder="请输入联系电话"
                maxlength="11"
                v-model="formLabelAlign.contactTel"
                class="contactPhone"
                @input="
                  Mixin_commonLimitInput(
                    'formLabelAlign.contactTel',
                    11,
                    0,
                    false
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 新增字段 -->
        <el-row>
          <el-col
            :span="24"
            v-for="item in formLabelAlign.addFieldListThree"
            :key="item.key"
          >
            <AddBtnCustomizeField
              isNewStyle
              :titleW="200"
              :labelW="79"
              :valueW="750"
              :form-data="item"
              @updateContent="updateContactCustomizeField"
              @deleteItem="deleteContactCustomizeField"
              :ref="`customizeField_${item.key}`"
            />
          </el-col>
        </el-row>
        <el-row  class="addField">
          <el-col :span="24">
            <el-form-item label="">
              <el-button
                @click="addCustomizeField(formLabelAlign.addFieldListThree)"
                class="btn-add"
                icon="el-icon-plus"
                style="font-weight:400"
                >新增字段</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <!--联系信息里的上传附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传附件" style="margin-bottom: 0">
              <UploadAttachments
                :fileList="formLabelAlign.contactFileList"
                @changeAttachment="
                  obj => {
                    formLabelAlign.contactFileList = obj
                  }
                "
              ></UploadAttachments>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="width: 58px; height: 34px; color: #969696; padding: 10px 15px"
          @click="cancel('ruleForm')"
          >取消</el-button
        >
        <el-button
          class="el-button--warning"
          style="width: 58px; height: 34px; padding: 10px 15px"
          @click="confirmClick()"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import apiUser from "@/api/apiUser/apiUser"
import { wokerForm } from "@/mixins/validate/work.js"
import reg from "@/utils/configReg"
import ApplicantInformation from "@/components/public/ApplicantInfoComponent.vue" //申请人信息
import AddBtnCustomizeField from "./components/AddBtnCustomizeField.vue" //新增字段
export default {
  mixins: [wokerForm],
  props: {
    dialogVisible: {
      // 控制dialog显示隐藏
      type: Boolean
    },
    dialogType: {
      // 1:工队 2:工程
      type: Number
    }
  },
  components: {
    ApplicantInformation, // 申请单位
    AddBtnCustomizeField,
    UploadAttachments: () =>
      import("@/components/public/uploadFiles/UploadAttachments.vue") //文件上传组件
  },
  data() {
    return {
      dialogLoading:false,
      isAdd: false, //是否新增 给团队处理申请人信息
      flag: false, //是否渲染申请人组件
      formLabelAlign: {
        companyNo: "",
        comprehend: "",
        question: "",
        requestAnswer: "",
        addFieldListOne: [], //原来得自定义字段
        fileList: [], //原附件
        markId: "",
        markName: "",
        markCreateNo: "",
        teamCreateType: 0,
        title: "",
        contactName: "", //客户名称
        contactUserName: "", //联系人
        contactTel: "", //联系电话
        /* 经办人信息 v2.1.8 */
        handleInfoDto: {
          companyName: "", //申请单位名称
          companyNo: "", //申请单位id
          departmentName: "", //申请部门名称
          departmentNo: "", //申请部门id
          userName: "", //经办人
          userNo: [] //经办人id
        },
        addFieldListTwo: [], //申请信息自定义字段
        addFieldListThree: [], //联系信息自定义字段
        contactFileList: [] //联系信息附件
      },
      rules: {
        question: [
          {
            required: true,
            message: "请输入疑问事项",
            trigger: "change"
          },
          {
            min: 5,
            max: 200,
            message: "长度在 5 到 200 个字符",
            trigger: "change"
          }
        ],
        contactUserName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "change"
          },
          {
            pattern: /^([\u4e00-\u9fa5·])+([\u4e00-\u9fa5·])+\·{0,2}$/,
            trigger: "blur",
            message: "请输入正确的联系人姓名"
          }
        ],
        contactTel: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change"
          },
          { pattern: reg.phone, message: "请输入正确联系电话" }
        ]
      }
    }
  },
  watch: {
    dialogVisible: {
      async handler(v) {
        if (!v) return
        this.dialogLoading=true  
        // 新增状态获取默认信息(团队不获取自己选)
        if (this.$store.state.user.type == 1) {
          let res = await apiResignAll.getUserInfo()
          let { code, data } = res.data
          if (res && code == 200) {
            this.formLabelAlign.handleInfoDto.companyName = data.companyName
            this.formLabelAlign.handleInfoDto.companyNo = data.comNo
            this.formLabelAlign.handleInfoDto.departmentName = data.deptName?data.deptName:'未分配部门'
            this.formLabelAlign.handleInfoDto.departmentNo = data.deptNo?data.deptNo:'1'
            this.formLabelAlign.handleInfoDto.userName = data.userName
            this.formLabelAlign.handleInfoDto.userNo = [data.userNo]
          }
        } 
          let res = await apiUser.getUserInfo()
          let { code, data } = res.data
          if (res && code == 200) {
            if(this.$store.state.user.type == 1){
            this.formLabelAlign.contactName = data.companyName
            }else if (this.$store.state.user.type == 2) {
            this.formLabelAlign.contactName = data.teamName
          }else if (this.$store.state.user.type == 0) {
            this.formLabelAlign.contactName = data.nickName||data.realName
          }
        }
        this.isAdd = true //新增
        this.flag = true //渲染申请子组件信息
        this.dialogLoading=false  
        if (v) {
          this.$nextTick(v => {
            this.$refs.ruleForm.clearValidate()
          })
        }
      },
      immediate: true //true 深度监听
    }
  },
  mounted() {
    this.dialogLoading=true
  },
  methods: {
    //更新联系信息新增字段
    updateContactCustomizeField(content) {
      let customizeField = this.formLabelAlign.addFieldListThree.find(
        obj => obj.key == content.key
      )
      Object.assign(customizeField, content)
    },
    //删除联系信息新增字段
    deleteContactCustomizeField(key) {
      this.formLabelAlign.addFieldListThree =
        this.formLabelAlign.addFieldListThree.filter(field => field.key != key)
    },
    //更新之前的新增字段
    updateCustomizeField(content) {
      let customizeField = this.formLabelAlign.addFieldListOne.find(
        obj => obj.key == content.key
      )
      Object.assign(customizeField, content)
    },
    //删除之前的新增字段
    deleteCustomizeField(key) {
      this.formLabelAlign.addFieldListOne =
        this.formLabelAlign.addFieldListOne.filter(field => field.key != key)
    },
    //新增字段限制个数
    addCustomizeField(addField) {
      if (addField.length < 5) {
        const isHaveInstance = addField.some((item) => !item.title && !item.value);
        const isHaveKey = addField.some((item) => !item.title);
        const isHaveValue = addField.some((item) => !item.value);
        if(isHaveInstance || isHaveKey || isHaveValue){
          this.$message({message: "请先填写新增字段内容",type: "warning",center: true,});
        }else{addField.push({title: "",value: "",key: this.uuid(),});}
      } else {
        this.$message({message: "最多只能新增五个字段",type: "warning",center: true,});
      }
    },
    //验证电话号码
    validPhone(rule, value, callback) {
      if (!value) {
        callback("请输入联系电话")
      } else {
        var reguPhone =
          /^((13[0-9])|(14[0,5,6,7,9])|(15([0-3]|[5-9]))|(16([6,7]))|(17([1-3]|[5-8]))|(18[0-9])|(19[1,3,5,8,9]))\d{8}$/ //手机号码验证regEx:第一位数字必须是1，11位数字
        var rePhone = new RegExp(reguPhone)
        if (rePhone.test(value)) {
          callback()
        } else {
          var regularEx = /^0\d{2,3}-\d{7,8}$/
          var reTel = new RegExp(regularEx)
          if (reTel.test(value)) {
            callback()
          } else {
            callback("联系电话不正确")
          }
        }
      }
    },
    //弹框关闭的叉叉
    cancleClick() {
      this.$emit("closeDialog", false)
    },
    //取消按钮
    cancel(formName) {
      this.formLabelAlign.addFieldListOne = []
      this.formLabelAlign.addFieldListTwo = []
      this.formLabelAlign.addFieldListThree = []
      this.formLabelAlign.fileList = []
      this.formLabelAlign.handleInfoDto = {}
      this.formLabelAlign.contactFileList = []
      this.$refs[formName].resetFields()
      this.$emit("closeDialog", false)
    },
    //提交按钮
    async confirmClick() {
      this.$refs["ruleForm"].validate(async valid => {
        if (valid) {
          this.dialogLoading=true  
          //验证自定义字段是否填写
          let childrensValidArr = []
          let childrenResult = true
          //原来的新增字段
          this.formLabelAlign.addFieldListOne.forEach(field => {
            const fieldItem = this.$refs[`customizeField_${field.key}`]
            const validResult = fieldItem[0].validateForm()
            childrensValidArr.push(validResult)
          })
          //联系信息的新增字段
          this.formLabelAlign.addFieldListThree.forEach(field => {
            const fieldItem = this.$refs[`customizeField_${field.key}`]
            const validResult = fieldItem[0].validateForm()
            childrensValidArr.push(validResult)
          })
          childrensValidArr.push(this.$refs.ruleForm.validate())
          await Promise.all(childrensValidArr)
            .then(() => {
              childrenResult = true
            })
            .catch(() => {
              childrenResult = false
            })
          if (!childrenResult) {
            return
          }
          //验证申请信息
          if(this.$store.state.user.type==1 || this.$store.state.user.type==2){
            const result =await this.$refs['applicantInformation'].validatorform()
            if(!result) {
              return
            }
        }
          //处理申请人经办人字段
          this.formLabelAlign.handleInfoDto.userNo = Array.isArray(
            this.formLabelAlign.handleInfoDto.userNo
          )
            ? this.formLabelAlign.handleInfoDto.userNo[0]
            : this.formLabelAlign.handleInfoDto.userNo
          //处理申请部门信息自定义字段参数
          this.formLabelAlign.addFieldListTwo =
            this.formLabelAlign.addFieldListTwo.map(item => {
              return { name: item.title, content: item.value }
            })
          // 处理原自定义字段
          this.formLabelAlign.addFieldListOne =
            this.formLabelAlign.addFieldListOne.map(item => {
              return { name: item.title, content: item.value }
            })
          // 处理联系信息里的自定义字段
          this.formLabelAlign.addFieldListThree =
            this.formLabelAlign.addFieldListThree.map(item => {
              return { name: item.title, content: item.value }
            })
          //单独处理个人身份下没有申请单位的情况
          if (this.$store.state.user.type == 0){
            this.formLabelAlign.handleInfoDto=null
          }
          let dataObj = {
            ...this.formLabelAlign
          }
          this.cancel("ruleForm")
          this.$emit("confirmDialog", dataObj)
        } else {
          return false
        }
      })
    },
    /**生成uuid@param len 长度@param radix 基数@returns {string} uuid*/
    uuid(len, radix) {
      let CHARS =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
          ""
        )
      let chars = CHARS,
        uuid = [],
        i
      radix = radix || chars.length

      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
      } else {
        let r

        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-"
        uuid[14] = "4"

        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16)
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r]
          }
        }
      }
      return uuid.join("")
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 20px 20px 0px 20px;
}
/deep/.el-textarea .el-input__count {
  bottom: 0px;
  right: 15px;
  color:#E4E7ED;
}
/deep/.el-dialog__header {
  height: 44px;
  line-height: 44px;
  padding: 0 20px;
  border-bottom: 1px solid #e4e7ed !important;
  .el-dialog__headerbtn{
    top: 15px;
  }
}
/deep/ .el-form-item {
  clear: both;
  margin-bottom: 15px!important;
}
/deep/.el-form-item__label {
  color: #333;
}
/deep/ .el-textarea .el-input__count {
  background: none;
}
/deep/.el-dialog__footer {
  text-align: center;
  padding: 20px;
}
/deep/.el-form-item__error{
  padding-top: 0px!important;
}
/deep/.el-textarea__inner{
  color: #666!important;
}
.customer {
  width: 200px !important;
  height: 34px !important;
  line-height: 34px !important;
  /deep/.el-input__inner {
    width: 200px !important;
    height: 34px !important;
    line-height: 34px;
    padding: 0 10px;
  }
}
.contact {
  width: 200px !important;
  height: 34px !important;
  line-height: 34px !important;
  /deep/.el-input__inner {
    width: 200px !important;
    height: 34px !important;
    line-height: 34px;
    padding: 0 10px;
  }
}
.contactPhone {
  width: 200px !important;
  height: 34px !important;
  line-height: 34px !important;
  /deep/.el-input__inner {
    width: 200px !important;
    height: 34px !important;
    line-height: 34px;
    padding: 0 10px;
  }
}
.dialogForm {
  .info-item-tt {
    font-size: 16px;
    border-left: 3px solid #0286df;
    padding-left: 10px;
    margin-bottom: 8px;
    color: #333;
  }
  .dashed-line {
    border-bottom: 1px dashed #e4e7ed;
    margin-bottom: 20px;
  }
}
.btn-add {
  border-color: #b79255;
  color: #b79255;
  background: #fff;
  padding: 7px 0px;
  width: 97px;
  height: 34px;
  &:hover,&:focus{
    border-color: #b79255;
    color: #b79255;
    background: #fff;
    }
}
/deep/.el-button--warning {
  background: #b79255;
  border-color: #b79255;
  &:hover {
    border-color: #b79255;
    background: #b79255;
  }
}
.dialog-footer {
  font-size: 14px;
}
/deep/.el-button [class*="el-icon-"] + span {
  margin-left: 0;
}
/deep/.contactMessage{
  .el-form-item__label{
    height: 34px;
    line-height: 34px;
  }
  .el-form-item__content{
  height: 34px!important;
  line-height: 34px!important;
  }
}
/deep/.addField{
  .el-form-item__content{
  height: 34px!important;
  line-height: 34px!important;
  }
}
</style>
